<template>
  <div
    id="providers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <v-toolbar dark :class="toolbarColor">
              <v-toolbar-title> {{ title }}</v-toolbar-title>
            </v-toolbar>
            <v-stepper v-model="next">
              <v-stepper-header>
                <v-stepper-step
                  :complete="next > 1"
                  step="1"
                >
                  Datos
                </v-stepper-step>

                <v-divider />

                <v-stepper-step
                  :complete="next > 2"
                  step="2"
                >
                  Roles
                </v-stepper-step>

                <v-divider />

                <v-stepper-step
                  :complete="next > 3"
                  step="3"
                >
                  Permisos
                </v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-layout
                    class="wrap justify-space-around form-body"
                  >
                    <v-col cols="12" v-if="disabled">
                      <v-select
                        v-model="form.type"
                        :items="items"
                        :rules="[rules.required]"
                        label="Tipo de Usuario"
                        required
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="form.name"
                        :rules="[rules.required]"
                        :maxlength="100"
                        label="Nombre"
                        placeholder="Pedro Perez"
                        required
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="form.email"
                        :rules="[rules.required, rules.emailRules]"
                        label="Correo Electrónico"
                        placeholder="ejemplo@dominio.com"
                        required
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="form.identificator"
                        :rules="[rules.identificatorFormat, rules.identificatorLength]"
                        :maxlength="11"
                        label="Identificación"
                        placeholder="Cédula"
                        required
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="form.phone"
                        :rules="[rules.phoneLength]"
                        v-mask="'####-###-####'"
                        :maxlength="13"
                        label="Teléfono"
                        placeholder="0123-456-7890"
                        type="tel"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-select
                        v-model="form.cat_province_id"
                        :items="itemsProvince"
                        item-value="id"
                        item-text="name"
                        label="Estado"
                        @change="getDistrito()"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-select
                        v-model="form.cat_district_id"
                        :items="itemsDistrict"
                        item-value="id"
                        item-text="name"
                        label="Municipio"
                        @change="getCorregimiento()"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-select
                        v-model="form.cat_corregimiento_id"
                        :items="itemsCorregimiento"
                        item-value="id"
                        item-text="name"
                        label="Parroquia"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.address"
                        :maxlength="300"
                        label="Dirección"
                        placeholder="Dirección"
                      />
                    </v-col>
                      <v-btn
                        color="success"
                        @click="validarDatos()"
                      >
                        Siguiente
                      </v-btn>
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-layout class="wrap justify-space-around form-body">
                    <v-col cols="12">
                      <v-select
                        v-if="user.role === 2"
                        v-model="form.role"
                        :items="items_role"
                        label="Rol de usuario"
                        :readonly="form.role === 3"
                        @change="selectRol()"
                      />
                      <v-select
                        v-else
                        v-model="form.role"
                        :items="items_role"
                        label="Rol de usuario"
                        @change="selectRol()"
                      />
                    </v-col>
                    <v-btn
                      :loading=" loading"
                      class="text-white"
                      :color="themeColor"
                      @click="next = 1"
                    >
                      regresar
                    </v-btn>
                    <v-btn
                      :loading=" loading"
                      color="success"
                      @click="validarRol()"
                    >
                      Siguiente
                    </v-btn>
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content step="3">
                  <v-layout class="wrap justify-space-around form-body">
                    <v-row class="custom-good-table" align="center" justify="space-around" style="width: 100%">
                      <v-col cols="12" v-if="loadedPermissions">
                        <vue-good-table
                          ref="Permisos"
                          :columns="columns"
                          :rows="rows"
                          :group-options="{
                            enabled: true,
                            collapsable: true
                          }"
                          :select-options="{
                            enabled: true,
                            selectionText: 'Permisos seleccionados',
                            clearSelectionText: 'Limpiar',
                            selectAllByGroup: true,
                          }"
                          @on-selected-rows-change="selectionChanged"
                        >
                        </vue-good-table>
                      </v-col>
                      <v-skeleton-loader
                        v-else
                        max-width="1700px"
                        type="table-tbody"
                      ></v-skeleton-loader>
                    </v-row>
                    <v-row align="center"
                    justify="space-around">
                      <!-- <div class="col-md-12"> -->
                        <v-btn
                          :loading=" loading"
                          class="text-white"
                          :color="themeColor"
                          @click="next = 2"
                        >
                          regresar
                        </v-btn>
                        <v-btn
                          :loading=" loading"
                          color="success"
                          @click="save"
                        >
                          Guardar
                        </v-btn>
                        <v-btn
                          :loading=" loading"
                          class="text-white"
                          color="red"
                          @click="cancel"
                        >
                          Cancelar
                        </v-btn>
                      <!-- </div> -->
                    </v-row>
                  </v-layout>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Form from 'vform';
  import { mask } from 'vue-the-mask';
  /* import FormToolbar from '~/components/Form/Toolbar'; */

  export default {
    /* components: {
      FormToolbar,
    }, */
    directives: {
      mask,
    },
    props: {
      enterpriseId: { default: null },
      id: { default: null },
      type: { default: null },
    },
    data: () => ({
      form: new Form({
        id: null,
        name: null,
        email: null,
        type: 'FEL',
        identificator: null,
        phone: null,
        cat_corregimiento_id: null,
        cat_district_id: null,
        cat_province_id: null,
        address: null,
        active: '1',
        busy: false,
        role: 'Seleccione...',
        items_permission: [],
      }),
      loadedPermissions: false,
      allPermissions: false,
      next: 1,
      items_role: [],
      items_permission: [],
      loadComplete: true,
      fel: null,
      receptor: null,
      disabled: false,
      itemsProvince: [],
      itemsDistrict: [],
      itemsCorregimiento: [],
      errores: null,
      valid: false,
      columns: [
        {
          label: 'Permiso',
          field: 'name',
        },
      ],
      rows: [],
      items_rol: [],
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        emailRules: (v) => /.+@.+\..+/.test(v) || 'Debe introducir un correo electrónico válido.',
        identificatorLength: (v) => (!v || v.length > 6) || 'El campo debe tener al menos 7 caracteres.',
        identificatorFormat: (v) => /^[A-Z0-9]+/g.test(v) || 'El campo solo permite letras mayusculas y numeros .',
        phoneLength: (v) => (!v || v.length === 13) || 'El campo debe tener de 11 caracteres numéricos.',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Nuevo Usuario',
      apiURL: '/api/enterprises',
      apiURLUser: 'users/store',
      method: 'POST',
      loading: false,
    }),
    computed: {
      ref() { return this.form.id; },
      items() {
        const items = [];
        if (this.fel) items.push('FEL');
        if (this.receptor) items.push('RECEPCION');
        return items;
      },
      ...mapGetters({
        user: 'auth/user',
        themeColor: 'theme/themeColor',
        toolbarColor: 'theme/toolbarColor',
      }),
    },
    watch: {
      'form.cat_province_id': {
        handler() {
          this.getDistrito();
        },
      },
      'form.cat_district_id': {
        handler() {
          this.getCorregimiento();
        },
      },
    },
    async mounted() {
      // this.reset();
      window.axios.get(`${this.apiURL}/${this.enterpriseId}`)
      .then((response) => {
        this.fel = response.data.id;
        this.receptor = response.data.receptor_id;
      });

      await this.getProvincia().then((response) => {
        this.itemsProvince = response.data;
      });

      const URL = `${this.apiURL}/${this.enterpriseId}/${this.apiURLUser}`;
      this.URL = URL;
      if (this.id) {
        window.axios.get(`${this.apiURL}/${this.enterpriseId}/users/${this.id}/type/${this.type}`)
        .then(async (result) => {
          Object.assign(this.form, result.data);
          if (this.type === 'FEL') {
            this.URL = `${this.apiURL}/${this.enterpriseId}/users/${this.id}/type/${this.type}/update`;
            this.method = 'PUT';
            this.title = 'Editar Usuario';
            /* if (result.data.role === 3) { */
              await this.getRoles(this.user.role).then((response) => {
                const roles = response.data.items.map((rol) => ({ value: rol.id, text: rol.name }));
                this.items_role = roles;
              });
            /* } else {
              await this.getRoles().then((response) => {
                const roles = response.data.items.map((rol) => ({ value: rol.id, text: rol.name }));
                this.items_role = roles;
              });
            } */
            /* if (result.data.role === 3) {
              await this.getRoles(3).then((response) => {
                const roles = response.data.items.map((rol) => ({ value: rol.id, text: rol.name }));
                this.items_role = roles;
              });
            } else {
              await this.getRoles().then((response) => {
                const roles = response.data.items.map((rol) => ({ value: rol.id, text: rol.name }));
                this.items_role = roles;
              });
            } */
            this.selectRol();
            const permissions = result.data.permissions.map((permission) => (permission.id));
            this.form.items_permission = permissions;
          }
          this.loadComplete = false;
        });
      } else {
        await this.getRoles().then((response) => {
          const roles = response.data.items.map((rol) => ({ value: rol.id, text: rol.name }));
          this.items_role = roles;
        });
      }
    },
    methods: {
      selectionChanged(params) {
        const permissions = params.selectedRows.map((item) => item.id);
        this.form.items_permission = permissions;
      },
      validate() {
        if (this.$refs.form.validate()) {
          this.snackbar = true;
          this.form.busy = true;
          this.store();
        }
      },
      selectRol() {
          const url = `/api/maintenance/roles/permissions/${this.form.role}/${this.enterpriseId}`;
          window.axios.get(url)
            .then((response) => {
            this.items_rol = response.data;
            // ----------------------------------------------------------------
            const categorias = [];
            this.rows = [];
            this.items_rol.forEach((item) => {
              if (!categorias.includes(item.description_category)) {
                categorias.push(item.description_category);
              }
            });
            categorias.forEach((categoria) => {
              const row = { name: categoria, children: [] };
              this.items_rol.forEach((item) => {
                if (categoria === item.description_category) {
                  row.children.push({ id: item.id, name: item.description });
                }
              });
              this.rows.push(row);
            });
            if (this.id) {
              this.rows.forEach((item, index) => {
                const children = item.children.map((child) => child.id);
                this.form.items_permission.forEach((itemPermission) => {
                  if (children.includes(itemPermission)) {
                    const index2 = children.indexOf(itemPermission);
                    this.$set(this.rows[index].children[index2], 'vgtSelected', true);
                  }
                });
              });
            }
            this.loadedPermissions = true;
          });
      },
      getRoles() {
        if (this.user.role === 1) {
          const role = 'P';
          const url = `/api/users/getRoles/${role}`;
          return window.axios.get(url);
        }
        if (this.user.role === 2) {
          const role = 'AU';
          const url = `/api/users/getRoles/${role}`;
          return window.axios.get(url);
        }
      },
      validarDatos() {
        if (this.$refs.form.validate()) {
            this.next = 2;
        }
      },
      validarRol() {
        if (this.$refs.form.validate()) {
            this.next = 3;
        }
      },
     store() {
        window.axios({
          method: this.method,
          url: this.URL,
          data: this.form,
        })
        .then(() => {
            this.loading = true;
            this.$router.go(-1);
        }).catch(() => {
          this.loading = false;
          this.form.busy = false;
        });
      },
      getProvincia() {
        const url = '/api/provinces';
        return window.axios.get(url);
      },
      getDistrito() {
        if (this.form.cat_province_id) {
            const url = `/api/districts/${this.form.cat_province_id}`;
            window.axios.get(url)
            .then((response) => {
            this.itemsDistrict = response.data;
          });
        }
      },
      getCorregimiento() {
        if (this.form.cat_district_id) {
            const url = `/api/corregimientos/${this.form.cat_district_id}`;
            window.axios.get(url)
            .then((response) => {
            this.itemsCorregimiento = response.data;
          });
        }
      },
      save() {
        this.loading = true;
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
     /*  reset() {
        this.form = new Form({
          id: null,
          name: null,
          email: null,
          type: null,
          identificator: null,
          phone: null,
          cat_corregimiento_id: null,
          cat_district_id: null,
          cat_province_id: null,
          address: null,
          active: '1',
          busy: false,
          role: null,
          items_permission: [],
        });
        this.resetValidation();
        this.title = 'Nuevo Usuario';
        this.disabled = false;
        this.URL = `${this.apiURL}/${this.enterpriseId}/users/store`;
        this.method = 'POST';
      }, */
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
    },
  };

</script>
